import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Import portions of React that are needed.
import React from 'react'; // Other standard imports.

import PropTypes from 'prop-types';
import cx from 'classnames';
import { pkg } from '../../settings';
import { useWebTerminal } from './hooks'; // The block part of our conventional BEM class names (blockClass__E--M).

var componentName = 'WebTerminalContentWrapper';
var blockClass = "".concat(pkg.prefix, "--web-terminal-content-wrapper");
export var WebTerminalContentWrapper = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useWebTerminal = useWebTerminal(),
      open = _useWebTerminal.open;

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cx([blockClass, _defineProperty({}, "".concat(blockClass, "--open"), open)])
  }, rest), children);
}); // Return a placeholder if not released and not enabled by feature flag

WebTerminalContentWrapper = pkg.checkComponentEnabled(WebTerminalContentWrapper, componentName); // The display name of the component, used by React. Note that displayName
// is used in preference to relying on function.name.

WebTerminalContentWrapper.displayName = componentName; // The types and DocGen commentary for the component props,
// in alphabetical order (for consistency).
// See https://www.npmjs.com/package/prop-types#usage.

WebTerminalContentWrapper.propTypes = {
  /**
   * Pass in content as children.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};